import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import unlockedFeaturesDataset from './datasets/unlocked_features_dataset';
import unlockedFeaturesFullNames from './datasets/unlocked_features_full_names';
import NumberedListFancyCard from '../shared-components/numbered_list_fancy_card';
import UnlockedFeatureText from './text/unlocked_feature_text';
import getUnlockedFeatureCriteria from './objectsStatus/get_unlocked_feature_criteria';
import buildFeatureTextArr from './objectsStatus/build_feature_text_arr';

class UnlockedFeaturesCriteriaModal extends Component {
            constructor(props) {
              super(props);
              this.state={
                  unlockedFeatureText: UnlockedFeatureText,
                  unlockedFeaturesCriteria: unlockedFeaturesDataset,
                  unlockedFeaturesFullName: unlockedFeaturesFullNames,
              } 
              this.featureTextArr = [];
              this.featureFound = false;
              this.none = "none";
              this.determineFeaturesText();  
    }
    
    determineFeaturesText(){
       
        this.featureDescription = "";
        let featureTextObj = this.state.unlockedFeatureText.find(elem => elem.feature === this.props.featureName);
        if (featureTextObj ){
            this.featureDescription = featureTextObj.text;
        }
        const featureCriteriaObj = getUnlockedFeatureCriteria(this.props.featureName, this.props.featureLevel, 
            this.props.featureStatus);
        this.currentLevel = featureCriteriaObj.currentLevel;
        this.featureCriteria = featureCriteriaObj.featureCriteria;
        this.featureFound = featureCriteriaObj.featureFound;
        this.featureEarnedLevel = featureCriteriaObj.levelEarned;
        let featureObj = 
            this.state.unlockedFeaturesFullName.find(elem => elem.featureName === this.props.featureName);
        const fullFeatureName = featureObj.fullName;
        this.headerText = fullFeatureName + " Criteria";
        this.currentLevelText = "";
        if (+this.currentLevel !== 0){
            this.currentLevelText = "You have earned and activated Level " + this.currentLevel + 
                " of this feature. " +
                "You can click on the " + fullFeatureName + " button to change your choices.";
        }
        if (this.featureFound === true){
            this.featureFoundText(fullFeatureName);
        }else{
             this.featureNotFoundText(fullFeatureName);
        }
    }
    
    featureFoundText(fullFeatureName){
        this.featureText = "In order to be eligible for level " + this.featureCriteria.level +
            " of the " + fullFeatureName + " feature, you must meet all of the following criteria." 
        this.eligible = true;
        const featureTextObj = buildFeatureTextArr(this.featureCriteria, 
            this.props.gameNbrMonths, this.props.currentCash, this.props.savings,
            this.props.monthlyIncome, this.props.creditReportObj, this.props.annualSalary, 
            this.eligible);
        this.featureTextArr = featureTextObj.featureTextArr;
        this.eligible = featureTextObj.eligible;
        if (this.eligible === true){
            if (this.props.featureLevel === this.featureEarnedLevel){
                this.eligibleText = "This feature has been unlocked but you are not currently taking advantage of " +
                    "this feature.";
            }else{
                this.eligibleText = "This feature has been earned, it will be unlocked at the end of your next " +
                    "turn in the game";
            }
        }else{
            this.eligibleText = "";
        }
    }
    
    featureNotFoundText(fullFeatureName){
        this.currentLevelText = "";
        this.featureText = "You have earned and activated all levels of this feature. " +
            "Click on the unlocked features button to the right and then the " + 
            fullFeatureName + " button if you would like to change the setup values."
    }

    render() {
      this.numberedList = this.featureTextArr.map((textLine, key) =>
          <NumberedListFancyCard key={key} text={textLine} />
        );


    return <>
      
      <Modal show={this.props.show}  onHide={() => this.props.onClose("none")} size="md" scrollable="true"
            dialogClassName={this.gutters} animation={false}>
        <Modal.Header className="backgroundTopBottom" closeButton>
          <Modal.Title className="text-center">{this.headerText}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
                  <div>{this.featureDescription}</div>
                    <div className="mt-2">  
                        {this.currentLevelText}
                    </div>
                    <div className="mt-2">
                        {this.featureText}
                    <div className="mt-1 mx-0 " >
                            <ul className="text-left mr-0">
                                {this.numberedList}
                            </ul>
                        </div>  
                    <div>{this.eligibleText}</div>
                  </div>
        </Modal.Body>
        </Modal>
        </>
    }

    
}

export default UnlockedFeaturesCriteriaModal;